import React from 'react';
import { Section } from '../../../Section';
import { SkeletonExpansible } from '../../../Skeleton';
export var BTopicSectionSkeleton = function BTopicSectionSkeleton(_ref) {
  var _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin;
  return React.createElement(Section, {
    bottomMargin: bottomMargin
  }, React.createElement(SkeletonExpansible, {
    style: {
      height: '360px'
    }
  }));
};